import { CONTACTS } from "./contacts";

export const LINKS = {
	home: "/",
	booking: "https://dikidi.net/1814231",
	about: "/#about",
	services: "/#services",
	contacts: "/#contacts",
	phone: `tel:${CONTACTS.phone.replace(/[^\d+]/g, "")}`,
	social: {
		vk: "https://vk.com/99barbershop",
		telegram: "https://t.me/barbershop_99",
		instagram: "https://www.instagram.com/99barber_shoop",
		whatsapp: "https://wa.me/79953254599",
	},
} as const;

export const BOOKING_UTM = {
	utm_source: "site",
	utm_medium: "referral",
	utm_campaign: "booking",
} as const;

export type BookingPlacement = "header" | "hero" | "services" | "cta";
